import React from 'react';
import PropTypes from 'prop-types';
import { DataDtmActions, Modes } from '../common/Constants';
import Tags from '../common/dtmTags';
import AlgoliaWrapper from '../directory/algolia/AlgoliaWrapper';

const ProducerDirectoryWithFilters = (props) => {
  const {
    algoliaConfig = {}, context, assets, navigation, testVariants, baseApiUrl
  } = props;

  const getIndexName = () => `artists_event-edition-${props.context.eventEditionId}`;
  const indexName = getIndexName();
  const pageTitle = decodeURIComponent(window?.reactSettingsArtistsDirectory?.props?.context?.title) || '';
  return (
    <div data-dtm={Tags.producerDirectory.component} data-dtm-actions={DataDtmActions.view}>
      <AlgoliaWrapper
        eventEditionId={context.eventEditionId}
        locale={context.interfaceLocale}
        appId={algoliaConfig.appId}
        indexName={indexName}
        apiKey={algoliaConfig.apiKey}
        navigation={navigation}
        context={context}
        assets={assets}
        testVariants={testVariants}
        showPlan={{}}
        baseApiUrl={baseApiUrl}
        pageTitle={pageTitle}
        directoryPage={'artist'}
      />
    </div>
  );
};

ProducerDirectoryWithFilters.propTypes = {
  assets: PropTypes.shape({
    defaultArtistLogoUrl: PropTypes.string.isRequired
  }).isRequired,
  navigation: PropTypes.shape({
    artistDetailsUrlFormat: PropTypes.string.isRequired
  }).isRequired,
  context: PropTypes.shape({
    eventEditionId: PropTypes.string.isRequired,
    interfaceLocale: PropTypes.string.isRequired,
    primaryLocale: PropTypes.string.isRequired,
    mode: PropTypes.oneOf([Modes.private, Modes.protected, Modes.public]),
    tenants: PropTypes.string
  }).isRequired,
  algoliaConfig: PropTypes.shape({
    appId: PropTypes.string.isRequired,
    apiKey: PropTypes.string.isRequired
  }).isRequired,
  testVariants: PropTypes.arrayOf(PropTypes.string),
  baseApiUrl: PropTypes.string.isRequired
};

export default ProducerDirectoryWithFilters;
